import React from "react";
import { ThemeConfig } from "./theme";
import { Provider } from "react-redux";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import { store, persistor } from "./redux/store";
import routes, { RenderRoutes } from "src/routes";
import ScrollToTop from "src/components/ScrollToTop";
import LoadingScreen from "src/components/LoadingScreen";
import AdapterDateFns from "@material-ui/lab/AdapterDateFns";
import NotistackProvider from "src/components/NotistackProvider";
import ConfirmProvider from "src/components/confirm/ConfirmProvider";
import { PersistGate } from "redux-persist/lib/integration/react";
import LocalizationProvider from "@material-ui/lab/LocalizationProvider";
import { makeStyles } from "@material-ui/core/styles";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

// Using for Auth (Check doc https://minimals.cc/docs/authentication)
import JwtProvider from "src/components/Auth/JwtProvider";
import { PinSessionOverlay } from "src/components/PinLoginDialog";
import ErrorBoundary from "./utils/ErrorBoundry";
import ErrorBoundaryGeneral from "./utils/ErrorBoundryGeneral";
import { installGlobalErrorHandler } from "./utils/globalErrorHandler";
import { InsightsKey, ServerApi } from "./config";
import SWNavigationBridge from "./SWNavigationBridge";
import DebugInstrumentation from "src/components/debug/DebugInstrumentation";
import AutoSaveDraftWatcher from "src/components/autoSave/AutoSaveDraftWatcher";
import { PWAInstallProvider } from "src/contexts/PWAInstallContext";

// 2026-08-25 · Handlers globales de errores JS (unhandledrejection +
// window.error) — muestran toast + reportan al slice `errors` (que
// alimenta el batch al `/api-monitor/batch`). Se instala una vez al
// cargar el módulo (idempotente).
installGlobalErrorHandler();

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    minHeight: "100%",
    alignItems: "center",
    paddingTop: theme.spacing(15),
    paddingBottom: theme.spacing(10),
  },
  header: {
    top: 0,
    left: 0,
    lineHeight: 0,
    width: "100%",
    position: "absolute",
    padding: theme.spacing(3, 3, 0),
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(5, 5, 0),
    },
  },
}));

const history = createBrowserHistory();

if (process.env.NODE_ENV === "production") {
  const browserHistory = createBrowserHistory({ basename: "" });

  var reactPlugin = new ReactPlugin();

  var appInsights = new ApplicationInsights({
    config: {
      connectionString: InsightsKey,
      extensions: [reactPlugin],
      enableAutoRouteTracking: true,
      // El navegador prohíbe `unload` (Permissions Policy) y lo avisa en
      // consola. Application Insights sigue enviando al salir con
      // `pagehide` y `visibilitychange` (hidden).
      disablePageUnloadEvents: ["unload", "beforeunload"],
      extensionConfig: {
        [reactPlugin.identifier]: { history: browserHistory },
      },
    },
  });
  appInsights.loadAppInsights();
}

// ----------------------------------------------------------------------

function App() {
  const classes = useStyles();

  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.register("/sw.js").catch(console.error);
  }

  const DevelopmentSettings = () => {
    return (
      // <ErrorBoundaryGeneral classes={classes}>
      <Provider store={store}>
        <PersistGate loading={<LoadingScreen />} persistor={persistor}>
          <ThemeConfig>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <NotistackProvider>
                <ConfirmProvider>
                <Router history={history}>
                  {/* <ErrorBoundary classes={classes} history={history}> */}
                  <PWAInstallProvider>
                    <JwtProvider>
                      <SWNavigationBridge />
                      <AutoSaveDraftWatcher />
                      <DebugInstrumentation />
                      <ScrollToTop />
                      {/* <GoogleAnalytics /> */}
                      {RenderRoutes(routes)}
                      <PinSessionOverlay />
                    </JwtProvider>
                  </PWAInstallProvider>
                  {/* </ErrorBoundary> */}
                </Router>
                </ConfirmProvider>
              </NotistackProvider>
            </LocalizationProvider>
          </ThemeConfig>
        </PersistGate>
      </Provider>
      // </ErrorBoundaryGeneral>
    );
  };

  return <DevelopmentSettings />;
}

export default App;
